import { getBusinessType } from './businessType';
import { isHeroBrandEnabled } from './heroBrandUtils';
import { getCachedCustomerServiceContacts } from '../services/brandingService';

// Last-resort contact details, used only until the public branding endpoint has answered
// for the first time — on a cold load with no network there is nothing else to show.
// They mirror the customer_service_phone_number and customer_service_email of the
// matching business type on the platform side.
export const TULKA_CUSTOMER_SERVICE_PHONE = '030 660 6400';
export const HEROTOLK_CUSTOMER_SERVICE_PHONE = '+47 51 51 74 90';
export const TULKA_CUSTOMER_SERVICE_EMAIL = 'info@tulka.com';
export const HEROTOLK_CUSTOMER_SERVICE_EMAIL = 'post@herotolk.com';

/**
 * The customer service number to point the user at, as written for a human reader.
 * Resolved from the most specific source available: the business type of the signed-in
 * user, then what the branding endpoint returned for the brand, then the constant above.
 * @returns {string}
 */
export const getCustomerServicePhone = () => {
  const businessType = getBusinessType();

  if (businessType?.customerServicePhoneNumber) {
    return businessType.customerServicePhoneNumber;
  }

  const fetched = getCachedCustomerServiceContacts();

  if (fetched?.phone) {
    return fetched.phone;
  }

  return isHeroBrandEnabled() ? HEROTOLK_CUSTOMER_SERVICE_PHONE : TULKA_CUSTOMER_SERVICE_PHONE;
};

/**
 * The same number as a dialable href. The spacing that makes the number readable is not
 * valid in a tel: URI, so it is stripped here.
 * @returns {string}
 */
export const getCustomerServicePhoneLink = () => `tel:${getCustomerServicePhone().replace(/\s/g, '')}`;

/**
 * The customer service address to point the user at, resolved like the number above.
 * @returns {string}
 */
export const getCustomerServiceEmail = () => {
  const businessType = getBusinessType();

  if (businessType?.customerServiceEmail) {
    return businessType.customerServiceEmail;
  }

  const fetched = getCachedCustomerServiceContacts();

  if (fetched?.email) {
    return fetched.email;
  }

  return isHeroBrandEnabled() ? HEROTOLK_CUSTOMER_SERVICE_EMAIL : TULKA_CUSTOMER_SERVICE_EMAIL;
};
